export const oktaConfig = {
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID || "0oa1c5pze9EXAMPLE",
  issuer:
    import.meta.env.VITE_OKTA_ISSUER ||
    "https://your-org.okta.com/oauth2/default",
  redirectUri:
    import.meta.env.VITE_OKTA_REDIRECT_URI ||
    window.location.origin + "/auth/callback",
  scopes: ["openid", "profile", "email"],
  pkce: true,
  disableHttpsCheck: import.meta.env.DEV,
};
